<template>
  <v-container style="min-height: 95%; max-height: 95%">
    <v-overlay :value="overlay" z-index="100">
      <v-progress-circular
        :size="50"
        color="grey lighten-4"
        indeterminate
      ></v-progress-circular>
    </v-overlay>

    <header>
      <div class="d-flex">
        <p class="title primary--text mt-0 mb-0 flex-grow-1">
          <span>{{ mensagem.nome }}</span>
        </p>
        <v-btn
          elevation="0"
          color="primary"
          text
          title="Adicionar contato"
          @click="add = true"
        >
          <v-icon left>mdi-account-multiple-plus</v-icon>
        </v-btn>
        <!-- <div>
          <p>
            <v-chip
              label
              color="default"
              pill
              v-for="t in mensagem.turma"
              :key="t.id"
              class="pa-md-4 mx-lg-auto m-2"
            >
              <span>
                {{
                  [
                    _.result(t, 'serie.nome'),
                    _.result(t, 'nome'),
                    _.result(t, 'serie.nivel.nome'),
                  ].join(' ')
                }}
              </span>
            </v-chip>
          </p>
        </div> -->
      </div>
    </header>
    <v-card>
      <v-tabs v-model="tabChat">
        <v-tab key="0" value="conversas">
          <v-icon>mdi-chat</v-icon>
          Conversa
        </v-tab>
        <!-- <v-tab class="ml-0" key="1" value="contatos">
          <v-icon>mdi-account-box</v-icon>
          Contatos
        </v-tab> -->
        <!-- <v-tab> Configurações </v-tab> -->
        <v-tab>Aluno</v-tab>
        <v-tab>Responsável</v-tab>
        <v-tab>Escola</v-tab>
        <v-tab>Confirmação de Leitura</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabChat" class="tab-item-wrapper">
        <v-tab-item class="tab-item-wrapper">
          <v-layout justify-center align-center v-show="progressCicurlar">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-layout>
          <div class="enviadas tab-item-wrapper-messages meuScroll" id="target">
            <v-container
              style="
                max-height: 60%;
                overflow-y: scroll;
                border-color: #ddd;
                border-style: solid;
                border-width: 1px;
              "
            >
              <v-row v-scroll:#target="onScroll" dense>
                <v-col
                  v-for="(msg, id) in mensagens"
                  :key="msg.id"
                  cols="12"
                  dense
                >
                  <v-card
                    outlined
                    :class="
                      `${msg.pessoa_id == pessoa_id ? 'float-right' : ''}`
                    "
                    :dark="msg.pessoa_id == pessoa_id"
                    max-width="80%"
                    min-height="90px"
                    max-height="400px"
                    :id="`msg-${id}`"
                    :color="msg.pessoa_id == pessoa_id ? '#1F7087' : ''"
                  >
                    <v-card-title class="overline">{{
                      msg.pessoa_id == pessoa_id
                        ? 'Você disse...'
                        : msg.pessoa.nome + ' disse...'
                    }}</v-card-title>
                    <v-card-text>
                      {{ msg.conteudo }}
                      <div>
                        <span class="data-hora"
                          ><small>{{
                            moment(msg.data_horario).format('LLL')
                          }}</small></span
                        >
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
            <v-container
              style="max-height: 145px; margin-top: 0; padding-top: 0"
            >
              <div class="row form-enviar">
                <div class="col-lg-12 col-md-12" style="max-height: 145px">
                  <div>
                    Você está enviando mensagem para:

                    <v-select
                      :items="enviarPara"
                      item-value="id"
                      item-text="nome"
                      v-model="menuSelected"
                      height="40px"
                      prepend-inner-icon="mdi-account-outline"
                    ></v-select>
                  </div>
                  <v-text-field
                    outlined
                    :append-icon="mensagemEnviada.conteudo ? 'mdi-send' : ''"
                    label="Digite uma mensagem..."
                    v-model="mensagemEnviada.conteudo"
                    class="search mt-2 pt-2"
                    @keyup.enter="mensagemEnviada.conteudo && enviar()"
                    @click:append="mensagemEnviada.conteudo && enviar()"
                  >
                  </v-text-field>
                </div>
              </div>
            </v-container>
          </div>
        </v-tab-item>

        <!-- <v-tab-item class="mx-1">
          <div>
            <div class="menu-header">
              
            </div>
            <v-text-field
              v-show="menuSelected === 3"
              label="Procurar por nome"
              height="40px"
              prepend-inner-icon="mdi-account-search-outline"
              v-model="search_participantesAdd"
              placeholder="Pesquisar..."
            >
            </v-text-field>
            <v-list subheader class="lista">
              <v-subheader v-show="menuSelected == 3"
                >Membros do grupo:</v-subheader
              >

              <v-list-item-group multiple v-model="participantesEnviados">
                <template v-for="msg in participantesAdicionados.data">
                  <v-list-item :key="msg.id" :value="msg.pessoa_id">
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          :true-value="msg"
                          color="deep-purple accent-4"
                          @click="toggle"
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="msg.nome"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>
          </div>
        </v-tab-item> -->

        <!-- <v-tab-item>
          <v-card>
            <v-card-title class="align-start">
              <div class="flex-fill">
                <v-container class="mb-3">
                  <v-row justify="center">
                    <v-col> </v-col>
                    <v-col>
                      <v-btn
                        class="mr-2"
                        elevation="0"
                        text
                        color="primary"
                        :to="`/mensagens/${mensagem.id}/editar`"
                      >
                        <v-icon left>mdi-pencil</v-icon>
                        <span>Editar</span>
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        class="mr-2"
                        elevation="0"
                        text
                        color="primary"
                        @click="desativar"
                      >
                        <template v-if="mensagem.ativo === 'N'">
                          <v-icon left>mdi-eye</v-icon>
                          <span>Ativar</span>
                        </template>
                        <template v-else>
                          <v-icon left>mdi-eye-off</v-icon>
                          <span>Desativar</span>
                        </template>
                      </v-btn>
                    </v-col>

                    <v-col>
                      <v-btn
                        class="mr-2"
                        elevation="0"
                        text
                        color="error"
                        @click="$refs.delete.request(mensagem.id)"
                      >
                        <v-icon left>mdi-delete</v-icon>
                        <span>Excluir</span>
                      </v-btn>
                    </v-col>

                    <v-spacer />
                  </v-row>
                </v-container>
              </div>
            </v-card-title>
            <v-card-text> </v-card-text>
          </v-card>
        </v-tab-item> -->
        <v-tab-item>
          <v-card>
            <v-card-title>
              <v-layout>
                <v-flex md12 xs12 class="mr-3">
                  <v-text-field
                    v-model="filtros.search"
                    label="Procurar"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="tabela_acompanhar_aluno.data"
              no-data-text="Não há mensagens disponíveis"
              no-results-text="Nenhuma mensagem encontrada"
              class="elevation-2"
              :loading="loadTabelaAcompAluno"
              :server-items-length="pagination.total"
              :options.sync="options"
              :footer-props="{
                'items-per-page-options': [50, 100, 150, 200]
              }"
            >
              <template #body="{ items }">
                <tbody>
                  <tr v-for="(item, id) in items" :key="id">
                    <td>{{ item.nome }}</td>
                    <td>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="primary"
                            class="mr-2"
                            icon
                            v-on="on"
                            @click="enviarSeparado(item)"
                          >
                            <v-icon>mdi-send</v-icon>
                          </v-btn>
                        </template>
                        Enviar mensagem</v-tooltip
                      >
                      <v-tooltip bottom v-if="item.ativo === 'S'">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="primary"
                            icon
                            v-on="on"
                            @click="desativarP(item.id)"
                          >
                            <v-icon>mdi-eye-off</v-icon>
                          </v-btn>
                        </template>
                        Desativar
                      </v-tooltip>
                      <v-tooltip bottom v-else>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="primary"
                            icon
                            v-on="on"
                            @click="desativarP(item.id)"
                          >
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        Ativar
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card>
            <v-card-title>
              <v-layout>
                <v-flex md12 xs12 class="mr-3">
                  <v-text-field
                    v-model="filtros2.search"
                    label="Procurar"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-data-table
              :headers="headers2"
              :items="tabela_acompanhar_responsavel.data"
              no-data-text="Não há mensagems disponíveis"
              no-results-text="Nenhuma mensagem encontrado"
              class="elevation-2"
              :loading="loadTabelaAcompAluno"
              :server-items-length="pagination2.total"
              :options.sync="options2"
              :footer-props="{
                'items-per-page-options': [50, 100, 150, 200]
              }"
            >
              <template #body="{ items }">
                <tbody>
                  <tr v-for="(item, id) in items" :key="id">
                    <td>{{ item.nome }}</td>
                    <td>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="primary"
                            class="mr-2"
                            icon
                            v-on="on"
                            @click="enviarSeparado(item)"
                          >
                            <v-icon>mdi-send</v-icon>
                          </v-btn>
                        </template>
                        Enviar mensagem</v-tooltip
                      >
                      <v-tooltip bottom v-if="item.ativo === 'S'">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="primary"
                            icon
                            v-on="on"
                            @click="desativarP(item.id)"
                          >
                            <v-icon>mdi-eye-off</v-icon>
                          </v-btn>
                        </template>
                        Desativar
                      </v-tooltip>
                      <v-tooltip bottom v-else>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="primary"
                            icon
                            v-on="on"
                            @click="desativarP(item.id)"
                          >
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        Ativar
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card>
            <v-card-title>
              <v-layout>
                <v-flex md12 xs12 class="mr-3">
                  <v-text-field
                    v-model="filtros2.search"
                    label="Procurar"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-data-table
              :headers="headers2"
              :items="tabelaEscola.data"
              no-data-text="Não há mensagems disponíveis"
              no-results-text="Nenhuma mensagem encontrado"
              class="elevation-2"
              :loading="loadTabelaAcompAluno"
              :server-items-length="pagination3.total"
              :options.sync="options3"
              :footer-props="{
                'items-per-page-options': [50, 100, 150, 200]
              }"
            >
              <template #body="{ items }">
                <tbody>
                  <tr v-for="(item, id) in items" :key="id">
                    <td>{{ item.nome }}</td>
                    <td>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="primary"
                            class="mr-2"
                            icon
                            v-on="on"
                            @click="enviarSeparado(item)"
                          >
                            <v-icon>mdi-send</v-icon>
                          </v-btn>
                        </template>
                        Enviar mensagem</v-tooltip
                      >
                      <v-tooltip bottom v-if="item.ativo === 'S'">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="primary"
                            icon
                            v-on="on"
                            @click="desativarP(item.id)"
                          >
                            <v-icon>mdi-eye-off</v-icon>
                          </v-btn>
                        </template>
                        Desativar
                      </v-tooltip>
                      <v-tooltip bottom v-else>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="primary"
                            icon
                            v-on="on"
                            @click="desativarP(item.id)"
                          >
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        Ativar
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="primary"
                            icon
                            v-on="on"
                            @click="setAdmin(item.id)"
                            v-if="item.admin === 'S'"
                            disabled
                          >
                            <v-icon>mdi-account-tie</v-icon>
                          </v-btn>
                          <v-btn
                            color="primary"
                            icon
                            v-on="on"
                            @click="setAdmin(item.id)"
                            v-else
                          >
                            <v-icon>mdi-account-tie</v-icon>
                          </v-btn>
                        </template>
                        Tornar Administrador
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card>
            <v-card-title>
              <v-layout>
                <v-flex md5 xs12 class="mr-3">
                  <v-text-field
                    v-model="filtros4.search"
                    label="Procurar"
                  ></v-text-field>
                </v-flex>
                <v-flex class="md2 align-items-baseline">
                  <v-menu
                    v-model="show_start_date"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    :disabled="data_enable"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="
                          filtros4.inicio
                            ? moment(filtros4.inicio).format('DD/MM/YYYY')
                            : ''
                        "
                        label="De:"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        :error-messages="
                          filtros4.fim && !filtros4.inicio
                            ? ['Informe a data de início']
                            : []
                        "
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filtros4.inicio"
                      @input="show_start_date = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex class="md2 align-bottom">
                  <v-menu
                    v-model="show_end_date"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="
                          filtros4.fim
                            ? moment(filtros4.fim).format('DD/MM/YYYY')
                            : ''
                        "
                        label="Até:"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        :error-messages="
                          filtros4.inicio && !filtros4.fim
                            ? ['Informe a data de fim']
                            : []
                        "
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filtros4.fim"
                      @input="show_end_date = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex class="md2 ml-3">
                  <v-select
                    v-model="filtros4.status"
                    :items="situacao"
                    label="Situação"
                    item-text="nome"
                    item-value="cod"
                  ></v-select>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex class="md1 mt-3 ml-3">
                  <v-btn color="primary" @click="filtros4 = []">Limpar</v-btn>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-data-table
              :headers="headers4"
              :items="mensagensEnviadasTab.data"
              no-data-text="Não há mensagems disponíveis"
              no-results-text="Nenhuma mensagem encontrado"
              class="elevation-2"
              :loading="loadTabelaAcompAluno"
              :server-items-length="pagination4.total"
              :options.sync="options4"
              :footer-props="{
                'items-per-page-options': [5, 10, 15, 20]
              }"
            >
              <template #body="{ items }">
                <tbody>
                  <tr v-for="(item, id) in items" :key="id">
                    <td>{{ id }}</td>
                    <td class="conteudo">{{ item.conteudo }}</td>
                    <td>
                      {{
                        item.data_horario &&
                          moment(item.data_horario).format('DD/MM/YYYY')
                      }}
                    </td>
                    <td>
                      <v-tooltip bottom v-if="item.ativa === 'S'">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="primary"
                            icon
                            v-on="on"
                            @click="desativarM(item.id)"
                          >
                            <v-icon>mdi-eye-off</v-icon>
                          </v-btn>
                        </template>
                        Desativar
                      </v-tooltip>
                      <v-tooltip bottom v-else>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="primary"
                            icon
                            v-on="on"
                            @click="desativarM(item.id)"
                          >
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        Ativar
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            icon
                            color="primary"
                            @click="getMensagem(item.id)"
                          >
                            <v-icon>mdi-message-settings-outline</v-icon>
                          </v-btn>
                        </template>
                        Dados da Mensagem
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <confirm ref="delete" :confirm-fn="remove"
      >Deseja excluir esta mensagem?</confirm
    >
    <v-dialog v-model="dadosMensagem" persistent max-width="600px">
      <v-card>
        <v-container>
          <v-row>
            <v-col>
              <div class="title text-center">Dados da Mensagem</div>
            </v-col>
          </v-row>
        </v-container>
        <v-btn
          icon
          color="primary"
          class="btn-close"
          @click="dadosMensagem = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-text>
          <v-container>
            <v-layout>
              <v-flex md7 xs12 class="mr-3">
                <v-text-field
                  v-model="filtros5.search"
                  label="Procurar"
                ></v-text-field>
              </v-flex>
              <v-flex class="md3 ml-3">
                <v-select
                  v-model="filtros5.tipo"
                  :items="tipoSelect"
                  label="Tipo"
                  item-text="text"
                  item-value="id"
                ></v-select>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex class="md1 mt-3 ml-3">
                <v-btn color="primary" @click="filtros5 = []">Limpar</v-btn>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headers5"
              :items="informacoesMensagem.data"
              no-data-text="Não há mensagems disponíveis"
              no-results-text="Nenhuma mensagem encontrado"
              class="elevation-2"
              :loading="loadTabelaAcompAluno"
              :server-items-length="pagination5.total"
              :options.sync="options5"
              :footer-props="{
                'items-per-page-options': [5, 10, 15, 20]
              }"
            >
              <template #body="{ items }">
                <tbody>
                  <tr v-for="(item, id) in items" :key="id">
                    <td>{{ item.nome }}</td>
                    <td v-if="item.chegou === 'S'">
                      <v-icon color="success">mdi-check</v-icon>
                    </td>
                    <td v-else><v-icon>mdi-close</v-icon></td>
                    <td v-if="item.leu === 'S'">
                      <v-icon color="success">mdi-check</v-icon>
                    </td>
                    <td v-else><v-icon>mdi-close</v-icon></td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="add" persistent max-width="900px">
      <v-card>
        <v-container>
          <v-row>
            <v-col>
              <div class="title text-center">Novos Participantes</div>
              <div class="subtitle-1 text-center">
                Adicione os participantes ao grupo, pesquisando o nome de cada
                um e logo após escolha os administradores.
              </div>
            </v-col>
          </v-row>
        </v-container>
        <v-btn icon color="primary" class="btn-close" @click="add = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-col>
                <div class="my-2 mt-8">
                  <v-label>Participante(s):</v-label>
                </div>
                <v-autocomplete
                  class="mb-2"
                  v-model="novosParticipantes"
                  :items="participantes.data"
                  :search-input.sync="search_participantes"
                  :loading="loadBar"
                  no-filter
                  placeholder="Digite o nome do participante"
                  solo
                  hide-selected
                  hide-details
                  item-text="nome"
                  :item-value="item => Object(item)"
                  :rules="[v => !!v || 'Item is required']"
                  required
                >
                </v-autocomplete>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Nº</th>
                        <th class="text-left">Nome</th>
                        <th class="text-left">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in participantesTabela"
                        :key="index"
                      >
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.nome }}</td>
                        <td>
                          <v-btn
                            color="primary"
                            icon
                            @click="admin(item)"
                            v-if="item.admin === 'S'"
                            disabled
                          >
                            <v-icon>mdi-account-tie</v-icon>
                          </v-btn>
                          <v-btn
                            color="primary"
                            icon
                            @click="admin(item)"
                            v-else
                          >
                            <v-icon>mdi-account-tie</v-icon>
                          </v-btn>
                          <v-btn
                            color="error"
                            icon
                            text
                            @click="removerItem(item)"
                          >
                            <v-icon left>mdi-delete</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12">
                <div class="my-2 float-right">
                  <v-btn outlined color="primary" @click="add = false"
                    >Voltar</v-btn
                  >
                  <v-btn class="primary" @click="addParticipante" width="200px"
                    >Adicionar</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="cor ? cor : ''">
      {{ text }}
      <v-btn color="primary" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { Mensagem } from '../../service'
import Confirm from '../../components/Confirm'

export default {
  components: { Confirm },
  data() {
    return {
      pessoa_id: 0,
      tabChat: 0,
      participantesTabela: [],
      valid: true,
      rules: [v => !!v || 'Campo requerido.'],
      idMensagem: null,
      dadosMensagem: false,
      informacoesMensagem: [],
      show_start_date: false,
      data_enable: false,
      start_date: null,
      show_end_date: false,
      end_date: null,
      mensagensEnviadasTab: [],
      progressCicurlar: false,
      mensagens: [],
      offsetTop: 0,
      mensagensEnviadas: [],
      search_participantesAdd: null,
      situacao: [
        { cod: 'S', nome: 'Ativado' },
        { cod: 'N', nome: 'Desativado' }
      ],
      enviarPara: [
        { id: 0, nome: 'Todos Participantes' },
        { id: 1, nome: 'Todos os Alunos' },
        { id: 2, nome: 'Todos os Responsáveis' },
        { id: 3, nome: '' }
      ],
      menuSelected: 0,
      tipoSelect: [
        { id: 'A', text: 'Aluno' },
        { id: 'R', text: 'Responsavel' },
        { id: 'E', text: 'Escola' }
      ],
      todosAlunos: false,
      participantesAdicionados: [],
      participantesEnviados: [],
      mensagemEnviada: {
        canal_comunicacao_id: this.$route.params.id,
        pessoa_id: localStorage.getItem('pessoa_id')
          ? localStorage.getItem('pessoa_id')
          : null,
        conteudo: ''
      },
      loadBar: false,
      administradores: [],
      participantes: [],
      novosParticipantes: [],
      add: false,
      sendForm: false,
      search_participantes: null,
      pagination: {
        current_page: 1,
        per_page: 5,
        total: 0
      },
      pagination2: {
        current_page: 1,
        per_page: 5,
        total: 0
      },
      pagination3: {
        current_page: 1,
        per_page: 5,
        total: 0
      },
      pagination4: {
        current_page: 1,
        per_page: 5,
        total: 0
      },
      pagination5: {
        current_page: 1,
        per_page: 5,
        total: 0
      },
      overlay: false,
      cor: '',
      snackbar: false,
      text: '',
      dialog: false,
      id: this.$route.params.id,
      mensagem: {},
      escola: localStorage.getItem('escola')
        ? localStorage.getItem('escola')
        : '',
      date: new Date().toISOString().substr(0, 10),
      tabela_acompanhar_aluno: [],
      tabela_acompanhar_responsavel: [],
      tabelaEscola: [],
      loadTabelaAcompAluno: false,
      filtros: {
        search: ''
      },
      filtros2: {
        search: ''
      },
      filtros3: {
        search: ''
      },
      filtros4: {
        search: '',
        start_date: '',
        end_date: '',
        inicio: null,
        fim: null,
        status: null
      },
      filtros5: {
        search: '',
        tipo: ''
      },
      menu: false,
      menu2: false,
      options: {},
      options2: {},
      options3: {},
      options4: {},
      options5: {},
      headers: [
        {
          text: 'Nome',
          value: 'aluno'
        },
        {
          text: 'Ações'
        }
      ],
      headers5: [
        {
          text: 'Nome',
          value: 'nome'
        },

        {
          text: 'Chegou',
          value: 'chegou'
        },
        {
          text: 'Leu',
          value: 'leu'
        }
      ],
      headers2: [
        {
          text: 'Nome',
          value: 'aluno'
        },
        {
          text: 'Ações'
        }
      ],
      headers4: [
        {
          text: 'Nº',
          value: 'id'
        },
        {
          text: 'Mensagem',
          value: 'conteudo'
        },
        {
          text: 'Data e hora',
          value: 'data_horario'
        },
        {
          text: 'Ações'
        }
      ],
      delay: 500
    }
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date)
    },
    todosParticipantes() {
      return (
        this.participantesEnviados.length ===
        this.participantesAdicionados.data.length
      )
    },
    turmasSelecionadas() {
      return this.participantesEnviados.length > 0 && !this.todosParticipantes
    },
    icon() {
      if (this.todosParticipantes) return 'mdi-close-box'
      if (this.turmasSelecionadas) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    icon_aluno() {
      if (this.todosAlunos) return 'mdi-close-box'
      else return 'mdi-minus-box'
    },
    dataTime(timestamp) {
      return new Date(timestamp)
    }
  },
  watch: {
    novosParticipantes: {
      deep: true,
      handler(item) {
        console.log(item)
        const index = this.participantesTabela.indexOf(item)
        console.log(index)
        if (index == -1) this.participantesTabela.push(item)
      }
    },
    search_participantesAdd: {
      deep: true,
      /* eslint-disable */
      handler() {
        clearTimeout(this.delay)
        if (this.search_participantesAdd) {
          if (this.search_participantesAdd.length > 2) {
            this.loadBar = true
            this.delay = setTimeout(() => this.getParticipantesGp(), 750)
            this.loadBar = false
          }
        } else {
          this.loadBar = false
          this.delay = setTimeout(() => this.getParticipantes(), 750)
        }
      },
    },
    search_participantes: {
      deep: true,
      /* eslint-disable */
      handler() {
        clearTimeout(this.delay)
        if (this.search_participantes) {
          if (this.search_participantes.length > 2) {
            this.loadBar = true
            this.delay = setTimeout(() => this.getParticipantes(), 750)
            this.loadBar = false
          }
        } else {
          this.loadBar = false
          this.delay = setTimeout(() => this.getParticipantes(), 750)
        }
      },
    },
    menuSelected: {
      deep: true,
      handler(item) {
        if (item != 3) {
          this.participantesAdicionados.data = []
          this.participantesEnviados = []
          this.enviarPara[3].nome = ''
        } else {
          this.getParticipantesGp()
        }
      },
    },
    $route(to) {
      this.id = to.params.id
    },

    date() {
      this.dateFormatted = this.formatDate(this.date)
    },
    options: {
      deep: true,
      async handler() {
        await this.tableAcompAluno()
      },
    },
    options2: {
      deep: true,
      async handler() {
        await this.tableAcompResponsavel()
      },
    },
    options3: {
      deep: true,
      async handler() {
        await this.loadtableEscola()
      },
    },
    options4: {
      deep: true,
      async handler() {
        await this.getMensagensEnviadasTab()
      },
    },
    options5: {
      deep: true,
      async handler() {
        await this.loadDadosMensagem()
      },
    },
    filtros: {
      deep: true,
      async handler() {
        await this.tableAcompAluno()
      },
    },
    filtros2: {
      deep: true,
      async handler() {
        await this.tableAcompResponsavel()
      },
    },
    filtros3: {
      deep: true,
      async handler() {
        await this.loadtableEscola()
      },
    },
    filtros4: {
      deep: true,
      async handler() {
        await this.getMensagensEnviadasTab()
      },
    },
    filtros5: {
      deep: true,
      async handler() {
        await this.loadDadosMensagem()
      },
    },
  },
  async created() {
    this.overlay = true
    await this.load()
    this.overlay = false
    this.pessoa_id = localStorage.getItem('pessoa_id')
  },
  methods: {
    scrollToEnd() {
      var container = document.querySelector('.meuScroll')
      console.log("AQUI");
      console.log(container.scrollHeight);
      var scrollHeight = container.scrollHeight
      container.scrollTop = scrollHeight
    },

    removerItem(item) {
      const index = this.participantesTabela.indexOf(item)
      if (index >= 0) this.participantesTabela.splice(index, 1)
    },

    async setAdmin(id) {
      try {
        await Mensagem.tornarAdmin(id, this.escola)
      } catch (erro) {
        this.snackbar = true
        this.text = erro
      }
    },
    async getMensagensEnviadasTab() {
      try {
        this.loadTabelaAcompAluno = true
        this.mensagensEnviadasTab = await Mensagem.mensagemEnviadas(
          this.mensagem.id,
          {
            ...this.filtros4,
            per_page: this.options4.itemsPerPage,
            page: this.options4.page,
            order: this.options4.sortBy ? this.options4.sortBy[0] : '',
            dir: this.options4.sortDesc == true ? 'DESC' : 'ASC',
            escola: this.escola,
          }
        )
        this.pagination4.total = this.mensagensEnviadasTab.total
        this.pagination4.current_page = this.mensagensEnviadasTab.current_page
        this.pagination4.per_page = parseInt(this.mensagensEnviadasTab.per_page)
      } catch (e) {
        //console.log(erro)
        this.loadTabelaAcompAluno = false
        this.snackbar = true
        this.text = 'Erro ao carregar a tabela de mensagens'
        this.cor = 'red'
      }
      this.loadTabelaAcompAluno = false
    },
    async getMensagensEnviadas() {
      this.mensagensEnviadas = await Mensagem.mensagemEnviadas(
        this.mensagem.id,
        {
          escola: this.escola,
        }
      )
      this.mensagens = this.mensagensEnviadas.data.reverse()
    },
    enviarSeparado(item) {
      if (this.participantesEnviados.length > 0) this.participantesEnviados = []
      this.participantesEnviados.push(item.pessoa_id)
      this.menuSelected = 3
      this.enviarPara[3].nome = item.nome
      this.sendForm = true
      this.tabChat = 0
    },
    AllParticipantes() {
      this.$nextTick(() => {
        if (this.todosParticipantes) {
          this.participantesEnviados = []
        } else {
          this.participantesEnviados = this.participantesAdicionados.data.map(
            (p) => p.id
          )
        }
      })
    },
    async getParticipantesGp() {
      this.participantesAdicionados = await Mensagem.getParticipantesDoGrupo(
        this.mensagem.id,
        {
          escola: this.escola,
          search: this.search_participantesAdd,
        }
      )
    },
    async getParticipantes() {
      this.participantes = await Mensagem.getParticipantes(this.mensagem.id, {
        escola: this.escola,
        search: this.search_participantes,
      })
    },
    removerAdm(item) {
      const index = this.administradores.indexOf(item)
      if (index >= 0) this.administradores.splice(index, 1)
    },
    admin(item) {
      const index = this.participantesTabela.indexOf(item)
      console.log(index)
      if (index >= 0) this.participantesTabela[index].admin = 'S'
    },
    removerParticipante(item) {
      const admIndex = this.administradores.indexOf(item)
      const index = this.novosParticipantes.indexOf(item.id)
      // console.log(admIndex)
      // console.log(index)
      if (index >= 0) this.novosParticipantes.splice(index, 1)
      if (admIndex >= 0) this.administradores.splice(admIndex, 1)
    },
    removerParticipanteEnviado(item) {
      const index = this.participantesEnviados.indexOf(item.id)
      //console.log(index)
      if (index >= 0) this.participantesEnviados.splice(index, 1)
    },
    async tableAcompAluno() {
      this.loadTabelaAcompAluno = true
      try {
        // const { sortBy, sortDesc, page, itemsPerPage } = this.options
        this.tabela_acompanhar_aluno = await Mensagem.exibirComunicacaoAluno(
          this.mensagem.id,
          {
            ...this.filtros,
            per_page: this.options.itemsPerPage,
            page: this.options.page,
            order: this.options.sortBy ? this.options.sortBy[0] : '',
            dir: this.options.sortDesc == true ? 'DESC' : 'ASC',
            escola: this.escola,
          }
        )
        // console.log('AAAAAAAAAAAAAAAAAAAAAAA', this.tabela_acompanhar_aluno)
        this.pagination.total = this.tabela_acompanhar_aluno.total
        this.pagination.current_page = this.tabela_acompanhar_aluno.current_page
        this.pagination.per_page = parseInt(
          this.tabela_acompanhar_aluno.per_page
        )
      } catch (erro) {
        //console.log(erro)
        this.loadTabelaAcompAluno = false
        this.snackbar = true
        this.text = 'Erro ao carregar a tabela de acompanhamento de aluno'
        this.cor = 'red'
      }
      this.loadTabelaAcompAluno = false
    },
    async loadtableEscola() {
      this.loadTabelaAcompAluno = true
      try {
        this.tabelaEscola = await Mensagem.exibirEscola(this.mensagem.id, {
          ...this.filtros3,
          per_page: this.options3.itemsPerPage,
          page: this.options3.page,
          order: this.options3.sortBy ? this.options3.sortBy[0] : '',
          dir: this.options3.sortDesc == true ? 'DESC' : 'ASC',
          escola: this.escola,
        })
        this.pagination3.total = this.tabelaEscola.total
        this.pagination3.current_page = this.tabelaEscola.current_page
        this.pagination3.per_page = parseInt(this.tabelaEscola.per_page)
      } catch (erro) {
        this.loadTabelaAcompAluno = false
        this.snackbar = true
        this.text = 'Erro ao carregar tabela de responsaveis'
        this.cor = 'red'
      }
      this.loadTabelaAcompAluno = false
    },
    async tableAcompResponsavel() {
      this.loadTabelaAcompAluno = true
      try {
        this.tabela_acompanhar_responsavel =
          await Mensagem.exibirComunicacaoResponsavel(this.mensagem.id, {
            ...this.filtros2,
            per_page: this.options2.itemsPerPage,
            page: this.options2.page,
            order: this.options2.sortBy ? this.options2.sortBy[0] : '',
            dir: this.options2.sortDesc == true ? 'DESC' : 'ASC',
            escola: this.escola,
          })
        this.pagination2.total = this.tabela_acompanhar_responsavel.total
        this.pagination2.current_page =
          this.tabela_acompanhar_responsavel.current_page
        this.pagination2.per_page = parseInt(
          this.tabela_acompanhar_responsavel.per_page
        )
      } catch (erro) {
        this.loadTabelaAcompAluno = false
        this.snackbar = true
        this.text = 'Erro ao carregar tabela de responsaveis'
        this.cor = 'red'
      }
      this.loadTabelaAcompAluno = false
    },
    async remove() {
      await Mensagem.delete(this.mensagem.id, { escola: this.escola })
      this.$router.back()
    },
    async load() {
      await this.loadInfoMensagens()
      await this.tableAcompAluno()
      await this.tableAcompResponsavel()
      await this.loadtableEscola()
      await this.getParticipantes()
      //await this.getParticipantesGp()
      await this.getMensagensEnviadas()
      await this.getMensagensEnviadasTab()
    },

    async loadDadosMensagem() {
      this.loadTabelaAcompAluno = true
      try {
        this.informacoesMensagem = await Mensagem.mensagensNaoLidas(
          this.idMensagem,
          {
            ...this.filtros5,
            per_page: this.options5.itemsPerPage,
            page: this.options5.page,
            order: this.options5.sortBy ? this.options5.sortBy[0] : '',
            dir: this.options5.sortDesc == true ? 'DESC' : 'ASC',
            escola: this.escola,
          }
        )
        this.pagination5.total = this.informacoesMensagem.total
        this.pagination5.current_page = this.informacoesMensagem.current_page
        this.pagination5.per_page = parseInt(this.informacoesMensagem.per_page)
      } catch (erro) {
        this.loadTabelaAcompAluno = false
        this.snackbar = true
        this.text = 'Erro ao carregar tabela de responsaveis'
        this.cor = 'red'
      }
      this.loadTabelaAcompAluno = false
    },
    async getMensagem(id) {
      this.idMensagem = id
      await this.loadDadosMensagem()
      this.dadosMensagem = true
    },
    async loadInfoMensagens() {
      this.mensagem = await Mensagem.findById(this.id, {
        escola: this.escola,
      })
    },

    async desativar() {
      this.mensagem = await Mensagem.desativar(this.id, this.escola)
      await this.loadInfoMensagens()
    },
    async desativarM(id) {
      await Mensagem.desativarMensagem(id, this.escola)
      await this.getMensagensEnviadasTab()
    },
    async desativarP(idParticipante) {
      await Mensagem.desativarParticipante(idParticipante, this.escola)
      await this.loadtableEscola()
      await this.tableAcompAluno()
      await this.tableAcompResponsavel()
      await this.mensagensEnviadasTab()
    },
    async onScroll(e) {
      this.offsetTop = e.target.scrollTop
      if (this.offsetTop == 0) {
        const prox_page = this.mensagensEnviadas.current_page + 1

        if (this.mensagensEnviadas.next_page_url) {
          this.progressCicurlar = true
          this.mensagensEnviadas = await Mensagem.mensagemEnviadas(
            this.mensagem.id,
            {
              escola: this.escola,
              page: prox_page,
            }
          )
          this.mensagens.unshift(...this.mensagensEnviadas.data.reverse())
          this.progressCicurlar = false
          e.target.scrollTop = 2
        }
      }
    },
    async enviar() {
      try {
        if (this.menuSelected == 3) {
          await Mensagem.enviar(
            {
              ...this.mensagemEnviada,
              idPessoas: this.participantesEnviados,
            },
            {
              escola: this.escola,
              tipo: 'D',
            }
          )
        } else if (this.menuSelected == 0) {
          await Mensagem.enviar(this.mensagemEnviada, {
            escola: this.escola,
            tipo: 'T',
          })
        } else {
          await Mensagem.enviar(this.mensagemEnviada, {
            escola: this.escola,
            tipo: this.menuSelected == 1 ? 'A' : 'R',
          })
        }

        await this.getMensagensEnviadas()
        this.scrollToEnd();

        this.mensagemEnviada.conteudo = ''
      } catch (e) {
        await this.load()
        this.snackbar = true
        this.text = 'Houve um erro ao enviar o mensagem'
        this.cor = 'red'
      }
    },
    async addParticipante() {
      if (this.$refs.form.validate() && this.participantesTabela.length > 0) {
        let part = this.participantesTabela.map((elem) => {
          if (elem.admin && elem.admin == 'S') {
            return { id: elem.id, admin: 'S' }
          } else {
            return { id: elem.id, admin: 'N' }
          }
        })
        const res = await Mensagem.adicionarParticipante(
          this.mensagem.id,
          { pessoas: part },
          {
            escola: this.escola,
          }
        )
        if (res) {
          this.snackbar = true
          this.text = 'Participantes adicionados!'
          this.cor = ''
          this.participantesTabela = []
          this.participantes = []
        } else {
          this.snackbar = true
          this.text = 'Ouve um erro ao adicionar novos participantes'
        }
      } else {
        this.snackbar = true
        this.cor = 'red'
        this.text = 'Inclua algum participante!'
      }
    },
  },
  mounted(){
    this.scrollToEnd();
  },
  formatDate(date) {
    if (!date) return null

    const [year, month, day] = date.split('-')
    return `${day}/${month}/${year}`
  },
  parseDate(date) {
    if (!date) return null

    const [month, day, year] = date.split('/')
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
  },
}
</script>

<style scoped>
.btn-close {
  position: absolute !important;
  top: 10px;
  right: 10px;
}

.form-enviar {
  align-self: baseline;
  max-height: 40%;
}

.data-hora {
  margin-top: 10px;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande',
    'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-size: 12px;
}
.search {
  margin: 5px;
  overflow: hidden;
}
.enviadas {
  height: 480px;
  position: relative;
}
.principal {
  position: relative;
  overflow: hidden;
}
.mensagem {
  overflow: auto;
  width: 100%;
}
.menu {
  position: relative;
}
.teste {
  overflow: hidden;
}
.menu-header {
  position: relative;
}
.lista {
  position: relative;
  overflow: auto;
  height: 400px;
}
.conteudo {
  max-width: 300px;
}

.tab-item-wrapper {
  /* vuetify sets the v-tabs__container height to 48px */
  height: calc(100vh - 170px);
}

.tab-item-wrapper-messages {
  /* vuetify sets the v-tabs__container height to 48px */
  height: calc(100vh - 40px);
}
</style>
